import { NgModule } from '@angular/core';
import { AuthModule } from '@freelancer/auth';
import { UiModule } from '@freelancer/ui';
import { CompatModalsComponent } from './compat-modals.component';

@NgModule({
  imports: [AuthModule, UiModule],
  declarations: [CompatModalsComponent],
  entryComponents: [CompatModalsComponent],
})
export class CompatModalsModule {}
